import { render, staticRenderFns } from "./VueSlider.vue?vue&type=template&id=06afdeac&scoped=true&"
import script from "./VueSlider.vue?vue&type=script&lang=js&"
export * from "./VueSlider.vue?vue&type=script&lang=js&"
import style0 from "./VueSlider.vue?vue&type=style&index=0&id=06afdeac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06afdeac",
  null
  
)

component.options.__file = "VueSlider.vue"
export default component.exports